export default __webpack_public_path__ + "static/media/III-2021.d88eb711.pdf";